<template>
  <form name="contract" class="needs-validation" novalidate>
    <div
      id="alert"
      class="alert alert-dismissible fade show m-alert m-alert--outline mb-4 mt-4"
      :class="alert.color"
      role="alert"
      v-if="alert.message"
      ref="alert"
    >
      <button type="button" class="close" aria-label="Close" @click="alert.message = ''"></button>
      <i :class="alert.icon"></i> &nbsp;<strong>{{ alert.message }}</strong
      ><br />
      {{ alert.reason }}
    </div>
    <div class="row mt-3">
      <div class="col-md-7">
        <div class="form-group" :class="{ 'has-danger': !discounts.customer_id }">
          <label for="customer_id"
            >Cliente <span v-if="!data.id" class="m--font-danger">*</span></label
          >
          <div class="input-group">
            <SelectCustomers
              ref="customer_id"
              :selected="discounts.customer_id"
              :first="'Selecione um cliente'"
              @change="discounts.customer_id = $event"
              :disabled="!!data.id"
            />
          </div>
        </div>
      </div>
      <div class="col-md-5">
        <div class="form-group">
          <label for="product_id"></label>
          <div class="clear-link">
            <a
              href="javascript:;"
              id="m_login_forget_password"
              @click="clearDiscounts()"
              class="m-link"
              >Limpar Formulário</a
            >
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-md-3">
        <div class="form-group">
          <label for="date">Tipo de bônus<span class="m--font-danger"> *</span></label>
          <div class="input-group">
            <div class="radio">
              <label>
                <input
                  type="radio"
                  name="type"
                  id="typeDiscount"
                  value="1"
                  v-model="discounts.type"
                  :checked="true"
                />
                Desconto
              </label>
            </div>
            <div class="radio">
              <label>
                <input
                  type="radio"
                  name="type"
                  id="typeAddition"
                  value="2"
                  v-model="discounts.type"
                />
                Acréscimos
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-md-4">
        <div class="form-group" :class="{ 'has-danger': isEmpty(this.discounts.start_date) }">
          <label for="date">Aplicar de<span class="m--font-danger"> *</span></label>
          <div class="input-group">
            <vue-monthly-picker
              inputClass="form-control m-input"
              selectedBackgroundColor="blue"
              dateFormat="MM/YYYY"
              :monthLabels="monthsLabels"
              v-model="discounts.start_date"
            >
            </vue-monthly-picker>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label for="date">Aplicar até</label>
          <div class="input-group">
            <vue-monthly-picker
              inputClass="form-control m-input"
              selectedBackgroundColor="blue"
              dateFormat="MM/YYYY"
              :monthLabels="monthsLabels"
              v-model="discounts.end_date"
            >
            </vue-monthly-picker>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-md-4">
        <div class="form-group" :class="{ 'has-danger': hasEmptyProductRow() }">
          <label for="product_id">Produto <span class="m--font-danger">*</span></label>
          <div class="input-group">
            <div class="input-group">
              <SelectProducts
                id="product_id"
                ref="product_id"
                :first="'Selecione um produto'"
                :selected="discounts.product_id"
                @change="updateProductIdValue($event)"
                v-model="discounts.product_id"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group" :class="{ 'has-danger': hasEmptyReasonRow() }">
          <label for="product_id">Motivo <span class="m--font-danger">*</span></label>
          <div class="input-group">
            <div class="input-group">
              <SelectDiscountReasons
                id="reason_id"
                ref="reason_id"
                :first="'Selecione um motivo'"
                :selected="discounts.reason_id"
                @change="updateReasonIdValue($event, discounts)"
                v-model="discounts.reason_id"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <hr class="row mt-5 mb-3" />
    <div v-for="service in discounts.services" :key="service.id" class="row mt-3">
      <div class="col-md-4">
        <div class="form-group" :class="{ 'has-danger': !discounts.services[0].serviceId }">
          <label for="productId">Serviço <span class="m--font-danger">*</span></label>
          <div class="input-group">
            <div class="input-group">
              <SelectProductServices
                id="serviceId"
                ref="serviceId"
                :first="'Selecione um serviço'"
                :selected="service.serviceId"
                :productId="discounts.product_id"
                @change="service.serviceId = $event"
                :servicesSelected="discounts.services"
                :getCountable="0"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group" :class="{ 'has-danger': !discounts.services[0].value }">
          <label>Valor <span class="m--font-danger">*</span></label>
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text">{{ symbolDiscount }}</span>
            </div>
            <money v-bind="money" class="form-control m-input" v-model="service.value"></money>
          </div>
        </div>
      </div>
    </div>
    <div>
      <button type="button" class="btn btn-sm btn-metal m-btn" @click="discounts.services.push({})">
        <i class="fas fa-plus-circle"></i> Adicionar valor
      </button>
    </div>
    <hr class="row mt-5 mb-3" />

    <div class="row">
      <div class="col-md-12 text-right">
        <p class="p-0 m-0">
          <a
            href="#"
            @click.prevent="$refs.customer_id.$el.focus()"
            target="_self"
            class="m--font-danger"
            v-if="!discounts.customer_id"
            >O campo <strong>Cliente</strong> é obrigatório *</a
          >
        </p>
        <p class="p-0 m-0">
          <a
            href="#"
            @click.prevent="$refs.customer_id.$el.focus()"
            target="_self"
            class="m--font-danger"
            v-if="isEmpty(this.discounts.start_date)"
            >O campo <strong>Aplicar de</strong> é obrigatório</a
          >
        </p>
        <p class="p-0 m-0">
          <a
            href="#"
            @click.prevent="$refs.customer_id.$el.focus()"
            target="_self"
            class="m--font-danger"
            v-if="hasEmptyProductRow()"
            >O campo <strong>Produto</strong> é obrigatório *</a
          >
        </p>
        <p class="p-0 m-0">
          <a
            href="#"
            @click.prevent="$refs.customer_id.$el.focus()"
            target="_self"
            class="m--font-danger"
            v-if="hasEmptyReasonRow()"
            >O campo <strong>Motivo</strong> é obrigatório *</a
          >
        </p>
        <p class="p-0 m-0">
          <a
            href="#"
            @click.prevent="$refs.customer_id.$el.focus()"
            target="_self"
            class="m--font-danger"
            v-if="!this.discounts.services[0].value || !this.discounts.services[0].serviceId"
            >O campo <strong>Serviço e Valor</strong> são obrigatórios *</a
          >
        </p>
      </div>
    </div>
    <div class="row mb-5">
      <div class="col-md-12 text-right">
        <button
          @click.prevent="saveForm()"
          class="btn"
          :class="{ 'btn-metal': !formIsValid, 'btn-focus': formIsValid }"
          :disabled="!formIsValid"
        >
          <i class="fas fa-save" v-if="formIsValid"></i>
          <i class="fas fa-exclamation-triangle" v-else></i>
          Salvar
        </button>
      </div>
    </div>
  </form>
</template>

<script>
import { Money } from 'v-money';
import SelectProducts from '@/components/forms/SelectProducts';
import SelectDiscountReasons from '@/components/forms/SelectDiscountReasons';
import { returnMessageFormMixin } from '@/mixins/returnMessageFormMixin';
import moment from 'moment';
import VueMonthlyPicker from 'vue-monthly-picker';
import SelectProductServices from '@/components/forms/SelectProductServices';
import snakecaseKeys from 'snakecase-keys';

import { baseApiUrl } from '@/global';
import axios from 'axios';
import SelectCustomers from '../forms/SelectCustomers';

const getEmptyDiscount = ({
  customer_id = null,
  type = '1',
  start_date = '',
  end_date = '',
  product_id = '',
  reason_id = '',
  services = [{ serviceId: null, value: 0 }],
}) => ({
  customer_id,
  type,
  start_date,
  end_date,
  product_id,
  reason_id,
  services,
});

export default {
  mixins: [returnMessageFormMixin],
  name: 'DiscountAdditionSaveForm',
  components: {
    SelectCustomers,
    SelectProducts,
    Money,
    SelectDiscountReasons,
    VueMonthlyPicker,
    SelectProductServices,
  },
  data() {
    return {
      data: {},
      discounts: getEmptyDiscount({ date: moment().format('YYYY-MM') }),
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: false,
        total: '',
      },
      symbolDiscount: 'R$',
      reasons: [],
      monthsLabels: [
        'Jan',
        'Fev',
        'Mar',
        'Abr',
        'Mai',
        'Jun',
        'Jul',
        'Ago',
        'Set',
        'Out',
        'Nov',
        'Dez',
      ],
    };
  },
  methods: {
    async saveForm() {
      await this.messageWaitingSave();

      const alertEl = this.$refs.alert;

      if (alertEl) {
        alertEl.scrollIntoView();
      }

      this.discounts.start_date = `${moment(this.discounts.start_date).format('YYYY-MM')}-01`;
      if (this.discounts.end_date) {
        this.discounts.end_date = `${moment(this.discounts.end_date).format('YYYY-MM')}-01`;
      }

      const url = `${baseApiUrl}/v1/customer/discount-addition/create`;
      axios
        .post(url, snakecaseKeys(this.discounts))
        .then((res) => {
          this.logMessageForm(res);
        })
        .catch((error) => {
          console.log(error);
          this.logMessageFormFailed(error.response);
        });
    },
    updateProductIdValue(product_id) {
      this.discounts.product_id = product_id;
    },
    updateReasonIdValue(reason_id) {
      this.discounts.reason_id = reason_id;
    },
    callData() {
      this.getCustomersWithDiscounts();
    },
    clearDiscounts() {
      this.discounts = getEmptyDiscount({ date: moment().format('YYYY-MM') });
      this.discounts.customer_id = 0;
    },
    hasEmptyProductRow() {
      let hasEmpty = false;
      if (this.discounts.product_id === '') {
        hasEmpty = true;
      }
      return hasEmpty;
    },
    hasEmptyReasonRow() {
      let hasEmpty = false;
      if (this.discounts.reason_id === '') {
        hasEmpty = true;
      }
      return hasEmpty;
    },
    isEmpty(value) {
      if (value === '' || value == null || value == 0) {
        return true;
      }
      return false;
    },
  },
  computed: {
    contractId() {
      return this.$store.state.showContractSave;
    },
    formIsValid() {
      if (
        this.discounts.customer_id &&
        !this.hasEmptyProductRow() &&
        !this.hasEmptyReasonRow() &&
        ((this.discounts.start_date && this.discounts.type == 1) ||
          (this.discounts.start_date && this.discounts.type == 2)) &&
        this.discounts.services[0].value &&
        this.discounts.services[0].serviceId
      ) {
        return true;
      }
      return false;
    },
  },
  beforeMount() {
    if (this.contractId && this.contractId != 'add') {
      this.callData();
    } else {
      this.data = {
        customer_id: 0,
        product_id: 0,
        due_day: '',
        start: '',
      };
    }
  },
};
</script>

<style scoped>
.clear-link {
  margin-top: 18px;
}
.btn-collapse {
  border-color: transparent;
  margin-top: 5px;
}
.radio {
  margin: auto;
}
</style>
